import React from 'react';

import {
  Flex,
} from 'web-styled';

import {
  Tooltip,
} from 'web-components';

import * as S from './styled';

type Tab = {
  to: string,
  name: string,
}

type Props = {
  tabs?: Array<Tab>,
  openedTooltips?: string[],
  onRemoveTooltip?: { (): void }
};

/**
 * Navigation Tabs
 * @version 1.0.0
 * @author [Ubayd Rahmonzoda](ubayd.rahmonzoda@gmail.com)
 */
const NavigationTabs = ({ tabs, openedTooltips, onRemoveTooltip }: Props) => (
  <Flex spacing={15} noPrint>
    {tabs.map(tab => (tab.name === 'assign' && openedTooltips.includes('assign')
      ? (
        <Tooltip
          toggleMode
          initialState
          body="Click Assign"
          preferPlace="left"
          key={tab.to}
        >
          <S.Tab
            to={tab.to}
            onClick={onRemoveTooltip}
          >
            {tab.name}
          </S.Tab>
        </Tooltip>
      ) : (
        <S.Tab
          key={tab.to}
          to={tab.to}
          exact
        >
          {tab.name}
          {tab.unread && <S.Unread />}
        </S.Tab>
      )))}
  </Flex>
);

NavigationTabs.defaultProps = {
  tabs: [],
  openedTooltips: [],
  onRemoveTooltip: () => null,
};

export default NavigationTabs;
